import { IMainMenuViewOption, MenuObject } from '@rbi-ctg/menu';
import { routes } from 'utils/routing';

export const optionToUrl = (option: IMainMenuViewOption | MenuObject, isBrowseMenu?: boolean) => {
  return `${!isBrowseMenu ? routes.menu : routes.browseMenu}/${option._type}-${option._id}`;
};
